export interface KeyboardShortcutsViewProps {
  onBack: () => void;
}

export const EMPTY_SEARCH_QUERY = '';

export interface ShortcutSection {
  headingKey: string;
  shortcuts: readonly ShortcutItem[];
}

export interface ShortcutItem {
  labelKey: string;
  /** Raw key string: a single combo ('ctrl+z'), an OS-alternate pair separated by ', ' ('⌘+z, ctrl+z'), or a bare key ('esc'). */
  keys: string;
}

export const SHORTCUT_LIST_SEPARATOR = ', ';

export const MAC_CMD_GLYPH = '⌘' as const;

export const MAC_DELETE_KEY = 'delete' as const;

export const SHORTCUT_SEPARATOR = '+';

export const SHORTCUTS_GENERAL: readonly ShortcutItem[] = [
  {labelKey: 'pmwjs_undo', keys: '⌘+z, ctrl+z'},
  {labelKey: 'pmwjs_redo', keys: '⌘+shift+z, ctrl+shift+z'},
  {labelKey: 'pmwjs_delete_an_item', keys: 'backspace, delete'},
  {labelKey: 'pmwjs_copy', keys: '⌘+c, ctrl+c'},
  {labelKey: 'pmwjs_paste', keys: '⌘+v, ctrl+v'},
  {labelKey: 'pmwjs_cut', keys: '⌘+x, ctrl+x'},
  {labelKey: 'pmwjs_duplicate', keys: '⌘+d, ctrl+d'},
  {labelKey: 'pmwjs_deselection', keys: 'esc'},
  {labelKey: 'pmwjs_lock_an_item', keys: '⌘+l, ctrl+l'},
  {labelKey: 'pmwjs_select_next_item', keys: 'tab'},
  {labelKey: 'pmwjs_select_previous_item', keys: 'shift+tab'},
  {labelKey: 'pmwjs_select_multiple_items', keys: '⌘+click, ctrl+click'},
  {labelKey: 'pmwjs_canvas_zoom_in', keys: '+'},
  {labelKey: 'pmwjs_canvas_zoom_out', keys: '-'},
  {labelKey: 'pmwjs_canvas_zoom_to_fit', keys: '⌘+0, ctrl+0'},
];

export const SHORTCUTS_TEXT: readonly ShortcutItem[] = [
  {labelKey: 'pmwjs_bold', keys: '⌘+b, ctrl+b'},
  {labelKey: 'pmwjs_italic', keys: '⌘+i, ctrl+i'},
  {labelKey: 'pmwjs_underline', keys: '⌘+u, ctrl+u'},
  {labelKey: 'pmwjs_strikethrough', keys: '⌘+s, ctrl+s'},
  {labelKey: 'pmwjs_text_left_align', keys: '⌘+shift+l, ctrl+shift+l'},
  {labelKey: 'pmwjs_text_center_align', keys: '⌘+shift+c, ctrl+shift+c'},
  {labelKey: 'pmwjs_text_right_align', keys: '⌘+shift+r, ctrl+shift+r'},
  {labelKey: 'pmwjs_text_justified_align', keys: '⌘+shift+j, ctrl+shift+j'},
];
